import { useEffect, useState } from "react";
import { getMarketplaces } from "../api";

let cachedMarketplaces = null;

export function useMarketplaces() {
  const [marketplaces, setMarketplaces] = useState(cachedMarketplaces);
  const [loading, setLoading] = useState(!cachedMarketplaces);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!cachedMarketplaces) {
      setLoading(true);
      getMarketplaces()
        .then((data) => {
          const formattedData = data
            .filter((p) => p.isConfigured === true)
            .map((item) => ({
              value: item.id,
              label: item.name,
            }));
          cachedMarketplaces = formattedData; // Cache the data
          setMarketplaces(formattedData);
          setLoading(false);
        })
        .catch((err) => {
          setError(err);
          setLoading(false);
        });
    }
  }, []);

  return { marketplaces, loading, error };
}
